<template>
    <EtatCommandesParUtilisateur/>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import EtatCommandesParUtilisateur from "@/components/GesCom/Etats/EtatCommandesParUtilisateur.vue";

  export default defineComponent({
    name: "EtatCommandesParUtilisateurPage",
    components: {
      EtatCommandesParUtilisateur,
    },
  });
</script>
